import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Phone number',
      placeholder: 'Enter phone number',
    },
  },
  otp: {
    resend: {
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: "Didn't receive the code via email?",
          button: 'Send Code via SMS →',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: "Didn't receive the code?",
          button: 'Resend Code via SMS →',
        },
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'A message with a verification code has been sent to your phone. Enter the code to continue.',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Please enter the code sent to this address: <br/> <strong>{{address}}</strong>',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Tip: Check your inbox and your spam folder.',
    },
  },
  error_messages: {
    frequent_requests:
      'Please check your SMS. We have already sent the code to the given number via SMS. If not, please check the phone number or try again in 10 minutes.',
    invalid_number: 'Invalid number. Please try again.',
    change_phone_number_unsuccessful: 'Failed to change phone number. Please try again.',
  },
  toasts: {
    code_sent: 'Code sent',
  },
};
